export const APP_VERSION = '0.0.0-local';
export const APP_RELEASE_FAMILY = null;
